import React, { useEffect, useState } from 'react'
import { useShared } from '../../hooks/useShared'
import AMenu from '../../components/partials/AMenu';
import MainSection from '../../components/sections/MainSection';
import APopover from '../../components/partials/APopover';
import PDFGenerateModal from '../../components/modals/PDFGenerateModal';
import QRGenerator from '../../components/qrcode/QRGenerator'
import { useParams } from 'react-router-dom';

const TABLE_HEAD = ["#", "ID", "شرکت", "کشور مقصد", 'اجناس', 'تـعـرفـه', 'شماره ايـنـوايس', 'فايل', 'تاریخ', 'اقدامات'];
const breadcrumbs = [{ name: 'مکتوب‌ها', link: '/export_duty_letters' },]
const menuData = [
    { flag: "Generate PDF", name: 'PDF ايجاد', icon: 'document-outline', roles: [1, 2, 27, 29], model: "export_duty_letter" },
    { flag: "Upload File", name: ' آپلود فایل', icon: 'cloud-upload-outline', roles: [1, 2, 4, 27, 29] },
    { flag: "Edit", name: 'ویرایش', icon: 'create-outline', roles: [1, 2, 4, 27, 29] },
    { flag: "Delete", name: 'حذف', icon: 'trash-outline', roles: [1, 2] },
]


const searchInputFields = [
    { label: 'شماره مکتوب.', name: 'letter_no', type: 'text', roles: [1, 2, 4, 27, 29], icon: 'text-outline', className: 'md:col-span-2', options: [] },
    { label: 'شماره اينوايس', name: 'invoice_number', type: 'text', roles: [1, 2, 4, 27, 29], icon: 'text-outline', className: 'md:col-span-2', options: [] },
    { label: 'شرکت', name: 'sCompany', type: 'select', roles: [1, 2, 27, 29], icon: 'text-outline', className: 'md:col-span-2', options: [] },
    { label: 'کشور', name: 'shipping_state', type: 'select', roles: [1, 2, 4, 27, 29], icon: 'text-outline', className: 'md:col-span-2', options: [] },
    { label: 'تاریخ', name: 'created_at', type: 'pdate', roles: [1, 2, 4, 27, 29], icon: 'book-outline', className: 'md:col-span-2' },
];



export default function ExportDutyLetter() {


    const params = useParams()
    const { com, model, setShowFilesModal, setModel, auth, models, navigate, generatePDF, location, setGeneratePDF, setShowViewDialog, setOpenUploadFileDialog, setOpenApproveDialog, showDeleteDialog, setShowDeleteDialog } = useShared();

    useEffect(() => {
        if (!auth.hasRole([1, 2, 4, 27, 29])) {
            return navigate("/db/notAllowed")
        }
    }, [])


    const handleMenu = (model, flag = false) => {
        console.log("handleMenu ", model, flag);

        if (flag === 'delete') {
            setModel(model)
            setShowDeleteDialog(!showDeleteDialog)
        }
        if (flag === 'edit') {
            setModel(model)
            // setShowNewModelDialog(true)
            navigate(`/db/export_duty_letters/0/new_letter/${model.id}`, { state: {} })
        }
        if (flag === 'view') {
            setModel(model)
            setShowViewDialog(true)
        }

        if (flag === 'generate pdf') {
            console.log(generatePDF)
            /*  <QRGenerator valueString={valueString} documentId={valueString} /> */

            setModel(model)
            setGeneratePDF(true)
        }
        if (flag === "upload file") {
            console.log("upload file");
            setModel(model)
            setOpenUploadFileDialog(pre => !pre)
        }

        if (flag === "approve") {
            console.log(flag);
            setModel(model)
            setOpenApproveDialog(pre => !pre)
        }

    };

    const openFilesDialog = (model) => {
        if (model?.attachments?.length > 0) {
            setModel(model)
            setShowFilesModal(true)
        }
    }

    const gotoToTariffs = (tId) => {
        navigate(`/db/tariffs/${tId}`)
    }

    const gotoToInvoice = (iId) => {
        navigate(`/db/invoices/${iId}`)
    }

    const handleViewDialog = (obj) => {
        return [
            { l: 'Name', v: obj?.name },
            { l: 'Type', v: obj?.parent?.label },
            { l: 'Description', v: obj?.description },
            { l: 'Added by', v: obj?.user?.full_name },
            { l: 'Status', v: obj?.status },
            { l: 'Last Update', v: com.ddmmyyhhmmA(obj?.updated_at) },
        ]
    }

    const getTableData = () => {
        return (<tbody className=''>
            {models?.data?.map((r, i) => {
                return (
                    <tr key={r.id}>
                        <td >{models?.from + i}</td>
                        <td>{r?.id}</td>
                        <th>{r?.company?.name_af}</th>
                        <td>{r?.invoice?.shipping_state?.label}</td>
                        <td style={{ direction: 'rtl' }}>
                            {r?.tariff?.items?.map((item, j) => {
                                return <span key={j} className='ml-1'>{item?.category?.label}{j < r?.items?.length - 1 && <span >،</span>} </span>
                            })}
                            <APopover v={{ data: itemsPopup(r?.tariff?.items), className: "mt-3" }} />
                        </td>
                        <td className='text-center'> <span className=' cursor-pointer text-blue-800 underline' onClick={() => gotoToTariffs(r?.letter_tariff?.value)}>{r?.letter_tariff?.label}</span></td>

                        <td className='text-center'> <span className=' cursor-pointer text-blue-800 underline' onClick={() => gotoToInvoice(r?.invoice?.value)}>{r?.invoice?.label}</span></td>
                        <td className='text-center'> <span className=' cursor-pointer text-blue-600' onClick={() => openFilesDialog(r)}>({r?.attachments?.length})</span></td>

                        <td style={{ direction: 'ltr' }}>
                            {com.dateConvert(r?.created_at, false, true)}
                            <p>{r?.user?.full_name}</p>
                        </td>
                        <td >
                            <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} />

                        </td>
                    </tr>
                )
            })}
        </tbody>)
    }


    const itemsPopup = (items) => <table style={{ direction: 'rtl' }} className=" gTable  ">
        <thead >
            <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'>
                <th>#</th>
                <th>نام</th>
                <th> اندازه (م م)</th>
                <th>قيمت (م م)</th>
                <th>نوع</th>
                <th>سورت</th>
            </tr>
        </thead>
        <tbody >
            {items?.map((item, i) => (
                <tr key={i + 1}>
                    <td>{1 + i}</td>
                    <td>{item?.category?.label} </td>
                    <td> {item?.quantity}</td>
                    <td> {item?.price_per_unit} ؋</td>
                    <td>{item?.item_type}</td>
                    <td>{item?.sort}</td>
                </tr>
            ))}
        </tbody>
    </table>




    return (
        <div>
            {/*   {generatePDF && <QRGenerator valueString={model?.id} documentId={model?.id} />} */}
            {/*  {generatePDF && <BlobProvider document={<PDFLetter v={{ model, com, http, }} />}
                fileName={'export_dupty_letter.pdf'}>
                {({ blob, url, loading, error }) => {
                    return (<> {loading ? <ASpinner /> : url ? downloadPDF(url) : null} </>)
                }}
            </BlobProvider>} */}

            <MainSection v={{
                handleViewDialog,
                newModelInputFields: [{ test: "new page" }],
                searchInputFields,
                TABLE_HEAD,
                breadcrumbs,
                tableData: getTableData(),
                addNewItemTitle: "مکتوب جديد",
                tableTitle: 'لست مکتوب‌ها',
                url: "exdletters",
                mUrl: { delete: 'exdletters', create: 'exdletters', getAll: 'exdlettersAdvanceSearch' },
                submitUrl: 'exdletters',
                advanceSearch: 'exdlettersAdvanceSearch',
                modelScreen: 'Export Duty Letters',
                attachName: 'ExportDutyLetter',
                searchData: { sCompany: { value: location?.state?.company_id }, letter_id: params.id },
                newModelDialogClassName: "h-[90%]"
            }} />

            {generatePDF && <PDFGenerateModal v={{ modelName: 'Letter' }} />}
        </div>

    )

}
